export const featuredProducts = [
  {
    id: 1,
    name: "Digital Marketing Mastery eBook",
    description: "Master digital marketing with proven strategies for SEO, content creation, social media, and video advertising to boost engagement and conversions.",
    price: 42,
    originalPrice: 89,
    image: "https://public.readdy.ai/ai/img_res/5125737fce673c122531724747584f27.jpg",
    category: "eBooks",
    rating: 4.8,
    reviews: 342,
    downloadCount: 1250,
    features: ["250+ Pages", "Downloadable PDF", "Bonus Templates", "Lifetime Updates"],
  },
  {
    id: 2,
    name: "Business Stock Image Library",
    description: "Premium collection of 500+ high-resolution business and office stock photos perfect for presentations, websites, and marketing materials.",
    price: 35,
    originalPrice: 79,
    image: "https://readdy.ai/api/search-image?query=professional%20business%20stock%20photography%20collection%2C%20office%20workspace%20images%2C%20team%20collaboration%20photos%2C%20corporate%20photography%20portfolio%2C%20clean%20modern%20presentation%20on%20white%20background&width=400&height=300&seq=prod2-business-stock&orientation=landscape",
    category: "Image Libraries",
    rating: 4.9,
    reviews: 289,
    downloadCount: 980,
    features: ["500+ Images", "High Resolution", "Commercial License", "Instant Download"],
  },
  {
    id: 3,
    name: "Social Media Video Templates",
    description: "Ready-to-use video templates for Instagram Reels, TikTok, and YouTube Shorts. Boost engagement with professional animated content.",
    price: 29,
    originalPrice: 59,
    image: "https://readdy.ai/api/search-image?query=professional%20social%20media%20video%20templates%20showcase%2C%20smartphone%20displaying%20Instagram%20reels%20and%20TikTok%20content%2C%20modern%20video%20marketing%20materials%2C%20clean%20presentation%20on%20white%20background&width=400&height=300&seq=prod3-social-video&orientation=landscape",
    category: "Mini Videos",
    rating: 4.7,
    reviews: 456,
    downloadCount: 1520,
    features: ["50+ Templates", "Easy Customization", "Multiple Formats", "Trending Styles"],
  },
  {
    id: 4,
    name: "E-commerce Blueprint Guide",
    description: "Complete step-by-step guide to launching and scaling your online store. Includes templates, checklists, and proven strategies.",
    price: 49,
    originalPrice: 99,
    image: "https://readdy.ai/api/search-image?query=professional%20ecommerce%20business%20guide%20ebook%20cover%2C%20online%20shopping%20cart%20graphics%2C%20digital%20commerce%20illustrations%2C%20modern%20business%20book%20design%20with%20orange%20and%20teal%20accents%20on%20white%20background&width=400&height=300&seq=prod4-ecommerce-guide&orientation=landscape",
    category: "eBooks",
    rating: 4.9,
    reviews: 523,
    downloadCount: 1680,
    features: ["300+ Pages", "Case Studies", "Templates Included", "Video Tutorials"],
  },
  {
    id: 5,
    name: "Lifestyle Photography Pack",
    description: "Authentic lifestyle photos featuring real moments, food, travel, and daily life. Perfect for blogs and social media content.",
    price: 39,
    originalPrice: 75,
    image: "https://readdy.ai/api/search-image?query=professional%20lifestyle%20photography%20collection%2C%20authentic%20moments%20with%20coffee%20food%20and%20travel%2C%20candid%20photography%20portfolio%2C%20warm%20natural%20lighting%2C%20clean%20presentation%20on%20white%20background&width=400&height=300&seq=prod5-lifestyle-photos&orientation=landscape",
    category: "Image Libraries",
    rating: 4.8,
    reviews: 367,
    downloadCount: 1120,
    features: ["400+ Photos", "Diverse Scenes", "High Quality", "Regular Updates"],
  },
  {
    id: 6,
    name: "Animated Logo Reveals",
    description: "Professional animated logo reveal templates for video intros. Make your brand memorable with stunning motion graphics.",
    price: 25,
    originalPrice: 49,
    image: "https://readdy.ai/api/search-image?query=professional%20animated%20logo%20reveal%20templates%2C%20motion%20graphics%20showcase%2C%20video%20intro%20animations%2C%20modern%20brand%20identity%20presentation%20on%20white%20background&width=400&height=300&seq=prod6-logo-reveals&orientation=landscape",
    category: "Mini Videos",
    rating: 4.6,
    reviews: 298,
    downloadCount: 890,
    features: ["30+ Animations", "HD Quality", "Easy Editing", "Multiple Styles"],
  },
  {
    id: 7,
    name: "Content Creation Masterclass",
    description: "Learn to create viral content across all platforms. Includes writing frameworks, design principles, and growth strategies.",
    price: 55,
    originalPrice: 119,
    image: "https://readdy.ai/api/search-image?query=professional%20content%20creation%20course%20ebook%20cover%2C%20social%20media%20marketing%20graphics%2C%20creative%20writing%20and%20design%20elements%2C%20modern%20educational%20book%20design%20on%20white%20background&width=400&height=300&seq=prod7-content-masterclass&orientation=landscape",
    category: "eBooks",
    rating: 4.9,
    reviews: 612,
    downloadCount: 2100,
    features: ["400+ Pages", "Video Lessons", "Workbooks", "Community Access"],
  },
  {
    id: 8,
    name: "Nature & Landscape Collection",
    description: "Breathtaking nature and landscape photography from around the world. Perfect for backgrounds, prints, and creative projects.",
    price: 45,
    originalPrice: 89,
    image: "https://readdy.ai/api/search-image?query=professional%20nature%20landscape%20photography%20collection%2C%20stunning%20mountain%20forest%20ocean%20scenes%2C%20travel%20photography%20portfolio%2C%20vibrant%20natural%20colors%2C%20clean%20presentation%20on%20white%20background&width=400&height=300&seq=prod8-nature-photos&orientation=landscape",
    category: "Image Libraries",
    rating: 4.9,
    reviews: 445,
    downloadCount: 1340,
    features: ["600+ Images", "4K Resolution", "Diverse Locations", "Seasonal Updates"],
  },
  {
    id: 9,
    name: "Product Demo Video Pack",
    description: "Professional product demonstration video templates. Showcase your products with sleek animations and modern transitions.",
    price: 32,
    originalPrice: 65,
    image: "https://readdy.ai/api/search-image?query=professional%20product%20demonstration%20video%20templates%2C%20modern%20product%20showcase%20animations%2C%20ecommerce%20video%20marketing%20materials%2C%20clean%20presentation%20on%20white%20background&width=400&height=300&seq=prod9-product-demos&orientation=landscape",
    category: "Mini Videos",
    rating: 4.7,
    reviews: 334,
    downloadCount: 1050,
    features: ["40+ Templates", "Product Focused", "Customizable", "Multiple Ratios"],
  },
  {
    id: 10,
    name: "Personal Branding Handbook",
    description: "Build a powerful personal brand that attracts opportunities. Strategies for LinkedIn, Twitter, and professional networking.",
    price: 38,
    originalPrice: 79,
    image: "https://readdy.ai/api/search-image?query=professional%20personal%20branding%20guide%20ebook%20cover%2C%20professional%20development%20graphics%2C%20career%20growth%20illustrations%2C%20modern%20business%20book%20design%20on%20white%20background&width=400&height=300&seq=prod10-personal-brand&orientation=landscape",
    category: "eBooks",
    rating: 4.8,
    reviews: 489,
    downloadCount: 1580,
    features: ["280+ Pages", "Templates", "Case Studies", "Action Plans"],
  },
  {
    id: 11,
    name: "Tech & Gadget Photo Library",
    description: "Modern technology and gadget photography. Smartphones, laptops, accessories, and workspace setups in high resolution.",
    price: 42,
    originalPrice: 85,
    image: "https://readdy.ai/api/search-image?query=professional%20technology%20gadget%20photography%20collection%2C%20modern%20smartphones%20laptops%20accessories%2C%20tech%20product%20photography%2C%20clean%20minimalist%20presentation%20on%20white%20background&width=400&height=300&seq=prod11-tech-photos&orientation=landscape",
    category: "Image Libraries",
    rating: 4.8,
    reviews: 378,
    downloadCount: 1190,
    features: ["450+ Images", "Latest Devices", "Clean Backgrounds", "Multiple Angles"],
  },
  {
    id: 12,
    name: "Explainer Video Templates",
    description: "Engaging explainer video templates perfect for tutorials, how-tos, and educational content. Simplify complex ideas visually.",
    price: 28,
    originalPrice: 55,
    image: "https://readdy.ai/api/search-image?query=professional%20explainer%20video%20templates%2C%20educational%20animation%20graphics%2C%20tutorial%20video%20materials%2C%20modern%20instructional%20design%20on%20white%20background&width=400&height=300&seq=prod12-explainer-videos&orientation=landscape",
    category: "Mini Videos",
    rating: 4.7,
    reviews: 412,
    downloadCount: 1280,
    features: ["35+ Templates", "Animated Icons", "Text Animations", "Easy to Edit"],
  },
];

export const productCategories = [
  {
    name: "eBooks",
    count: featuredProducts.filter(p => p.category === "eBooks").length,
    icon: "ri-book-line"
  },
  {
    name: "Image Libraries",
    count: featuredProducts.filter(p => p.category === "Image Libraries").length,
    icon: "ri-image-line"
  },
  {
    name: "Mini Videos",
    count: featuredProducts.filter(p => p.category === "Mini Videos").length,
    icon: "ri-video-line"
  }
];
